import { ApiService } from '../ApiService';
import type { 
  BalanceSheetData, 
  IncomeStatementData, 
  CashFlowStatementData,
  EquityChangesData,
  NotesData,
  FinancialStatementType
} from '../../../types/reports';
import { CurrencyCode } from '../../../config/currency';

export const reportsApi = {
  getBalanceSheet: (params: { 
    date: string;
    comparative?: boolean;
    currency?: CurrencyCode;
  }) => 
    ApiService.get<BalanceSheetData>('/reports/balance-sheet', params),

  getIncomeStatement: (params: { 
    startDate: string;
    endDate: string;
    comparative?: boolean;
    currency?: CurrencyCode;
  }) => 
    ApiService.get<IncomeStatementData>('/reports/income-statement', params),

  getCashFlowStatement: (params: {
    startDate: string;
    endDate: string;
    comparative?: boolean;
    currency?: CurrencyCode;
  }) => 
    ApiService.get<CashFlowStatementData>('/reports/cash-flow', params),

  getEquityChanges: (params: {
    startDate: string;
    endDate: string;
    currency?: CurrencyCode;
  }) =>
    ApiService.get<EquityChangesData>('/reports/equity-changes', params),

  getNotes: (params: {
    date: string;
    type: 'balance' | 'income' | 'all';
  }) =>
    ApiService.get<NotesData>('/reports/notes', params),

  generateReport: (params: {
    type: FinancialStatementType;
    format: 'pdf' | 'excel' | 'json';
    date?: string;
    startDate?: string;
    endDate?: string;
    comparative?: boolean;
    currency?: CurrencyCode;
    includeNotes?: boolean;
    filters?: {
      analytical_account_id?: string;
      cost_center_id?: string;
    };
  }) => {
    if (params.format === 'json') {
      // Pour JSON, retourner les données structurées
      return ApiService.post<any>('/reports/generate', params);
    } else {
      // Pour PDF/Excel, retourner un blob
      return ApiService.post<Blob>('/reports/generate', params);
    }
  },

  exportReport: (params: {
    type: FinancialStatementType;
    format: 'pdf' | 'excel';
    data: any;
  }) =>
    ApiService.post<Blob>('/reports/export', params),

  // Nouveaux endpoints pour recherche et filtres avancés
  searchReports: (params: {
    query: string;
    type?: FinancialStatementType;
    startDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
  }) =>
    ApiService.get<any>('/reports/search', params),

  getReportTemplates: () =>
    ApiService.get<any[]>('/reports/templates'),

  saveReportTemplate: (template: {
    name: string;
    type: FinancialStatementType;
    configuration: any;
  }) =>
    ApiService.post<any>('/reports/templates', template)
};